module.exports = __webpack_public_path__ + "media/images/plans/ceremony/hall-list/plan-ceremony-lineup-kanto-1-97535613ac73ff0beb934abef8158c18.png";